import { Injectable } from "@angular/core";
import { EzoomApiProvider } from "./ezoom-api";

@Injectable()
export class NotificationsProvider {
    constructor(public api: EzoomApiProvider) {}

    public getItem(id_notification: any) {
        return new Promise((resolve, reject) => {
            this.api
                .post("notifications/getNotification", {
                    id_notification: id_notification,
                })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject([]);
                    }
                });
        });
    }

    public getReceivedStatus(id_receiver: any) {
        return new Promise((resolve, reject) => {
            this.api
                .post("notifications/getReceivedStatus", {
                    id_receiver: id_receiver,
                })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject([]);
                    }
                });
        });
    }

    public schedulePushWelcome() {
        return new Promise((resolve, reject) => {
            this.api
                .post("notifications/schedule_push_welcome", {})
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject([]);
                    }
                });
        });
    }

    public getNotifications(page: number) {
        return new Promise((resolve, reject) => {
            this.api
                .get("notifications/getNotifications", { page: page })
                .subscribe((response: any) => {
                    console.log(response);
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject([]);
                    }
                });
        });
    }

    public getUnreadCount() {
        return new Promise((resolve, reject) => {
            this.api
                .get("notifications/getUnreadCount")
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject([]);
                    }
                });
        });
    }

    public readAll() {
        return new Promise((resolve, reject) => {
            this.api.get("notifications/readAll").subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject([]);
                }
            });
        });
    }

    public readNotification(id_receiver: any) {
        return new Promise((resolve, reject) => {
            this.api
                .post("notifications/read", { id_receiver: id_receiver })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.data);
                    } else {
                        reject([]);
                    }
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/notifications.ts